import styled from 'styled-components';
import { colors } from '@alixpartners/ui-components';

export const Container = styled.div`
  display: flex;
`;

export const Section = styled.div`
  display: flex;
  flex-direction: column;

  &:first-child {
    margin-right: 8px;
  }
`;

export const Title = styled.div`
  color: ${colors.grey8};
  font-size: 11px;
  letter-spacing: 0.8px;
  text-align: right;
  text-transform: uppercase;
  margin-bottom: 2px;
  line-height: 13px;
`;

export const Helper = styled.div`
  color: ${colors.grey5};
  font-size: 11px;
  text-align: right;
  line-height: 13px;
`;

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${colors.amber};
  color: ${colors.white};
  border-radius: 50%;
  height: 28px;
  width: 28px;
`;
